exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row {\n  margin: 0.4rem 0 0.4rem 0; }\n\n.contunue-action-container {\n  border-top: 1px solid silver; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/crm/crm-continue-action/crm-continue-action.component.scss
// module id = ../../../../../src/app/crm/crm-continue-action/crm-continue-action.component.scss
// module chunks = main